var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 36,
    viewBox: "0 0 329 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6128 8.41699L70.179 26.936L65.5129 35.2814L51.0859 8.41699H59.6128Z",
    fill: "url(#paint0_linear_11_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6759 8.41699L73.508 19.5755L72.7045 12.4961L66.3223 8.41699H79.6759Z",
    fill: "#31F6A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.086 8.41895L55.6487 16.7628L45.0844 35.1994H36.5557L51.086 8.41895Z",
    fill: "#24B4D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M51.0855 8.41846L50.2949 9.96386L55.6482 16.7623L51.0855 8.41846Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.512 10.5577V32.8838H113.268L99.5593 18.1522V32.8838H93.3154V11.4199L99.5593 9.98291L113.268 24.7102V10.5577H119.512Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.426 28.0151H150.074L148.429 32.8838H125.333V9.98291H150.074L148.429 14.8517H131.426V19.0146H147.272V23.9012H131.426V28.0151Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.44 9.98291H181.753L170.644 21.2771L182.093 32.8838H174.78L166.089 24.0047L157.399 32.8838H150.075L161.525 21.2771L150.416 9.98291H157.739L166.089 18.5362L174.44 9.98291Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.093 9.98291H209.745L208.042 14.8517H198.153V32.8838H191.847V14.8517H182.093V9.98291Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.745 9.98291H216.411L221.468 27.0177L228.914 9.98291H232.777L240.223 27.0177L245.28 9.98291H251.951L243.367 32.6393L237.048 34.1561L230.843 19.153L224.441 32.6393L218.117 34.1561L209.745 9.98291Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.645 25.346H267.731L262.79 16.0794L253.954 32.8838H247.585L259.632 11.4199L265.676 9.98291L278.148 32.8838H271.778L270.177 29.8922H258.426L260.645 25.346Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.985 32.8838H283.683V24.9733L270.871 9.98291H278.185L286.875 20.7031L295.566 9.98291H302.889L289.995 25.0939L289.985 32.8838Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_4",
    x1: 51.0859,
    y1: 21.8492,
    x2: 70.179,
    y2: 21.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#31F6A9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0fc63adc2a830e5953c5388ebc1dc48b.svg";
export { ForwardRef as ReactComponent };